import { generateTimeOptions } from '@/services/seller/discount/discount-time';

interface TimeSettingSectionProps {
  type: 'deadline' | 'reservation';
  pickupStartTime: string;
  pickupEndTime: string;
  onPickupStartTimeChange: (time: string) => void;
  onPickupEndTimeChange: (time: string) => void;
  orderStartTime?: string;
  orderEndTime?: string;
  showOrderHelper?: boolean;
}

export function TimeSettingSection({
  type,
  pickupStartTime,
  pickupEndTime,
  onPickupStartTimeChange,
  onPickupEndTimeChange,
  orderStartTime,
  orderEndTime,
  showOrderHelper = true
}: TimeSettingSectionProps) {
  const timeOptions = generateTimeOptions(0, 23); // 00:00~23:30까지 30분 단위

  // 예약할인은 시간 설정 불필요
  if (type === 'reservation') {
    return null;
  }

  return (
    <div className="bg-white rounded-lg p-4 mb-6 shadow-sm">
      <h2 className="text-lg font-semibold text-gray-800 mb-4">수령가능시간</h2>
      
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm text-gray-600 mb-1">수령시작시간</label>
          <select
            value={pickupStartTime}
            onChange={(e) => onPickupStartTimeChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            {timeOptions.map(time => (
              <option key={time} value={time}>{time}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label className="block text-sm text-gray-600 mb-1">수령종료시간</label>
          <select
            value={pickupEndTime}
            onChange={(e) => onPickupEndTimeChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            {timeOptions.map(time => (
              <option key={time} value={time}>{time}</option>
            ))}
          </select>
        </div>
      </div>
      
      {/* 주문 가능 시간 표시 */}
      {orderStartTime && orderEndTime && (
        <div className="mt-4 p-3 bg-blue-50 rounded-lg">
          <p className="text-sm text-blue-700">
            주문가능시간: {orderStartTime} ~ {orderEndTime}
          </p>
          {showOrderHelper && (
            <p className="text-xs text-blue-600 mt-1">
              (수령시작 30분 전부터 주문 가능)
            </p>
          )}
        </div>
      )}

      {/* 시간 유효성 경고 */}
      {pickupStartTime >= pickupEndTime && (
        <div className="mt-4 p-3 bg-red-50 rounded-lg">
          <p className="text-sm text-red-700">
            ⚠️ 수령종료시간은 수령시작시간보다 늦어야 합니다
          </p>
        </div>
      )}
    </div>
  );
}
